import revive_payload_client_4sVQNw7RlN from "/app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/app/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import index_NWk1yt4Jr2 from "/app/plugins/constants/index.ts";
import index_U7GSWh8vua from "/app/plugins/functions/index.ts";
import services_eN9fWZLDQ0 from "/app/plugins/services.ts";
import vue_notification_wWTm433X42 from "/app/plugins/vue-notification.ts";
import primevue_7rYYRZQLyx from "/app/plugins/primevue.ts";
import storage_5ozezXsAZX from "/app/plugins/storage.ts";
import i18n_VfGcjrvSkj from "/app/plugins/i18n.ts";
import nats_Jo7eXz1ICQ from "/app/plugins/nats.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  index_NWk1yt4Jr2,
  index_U7GSWh8vua,
  services_eN9fWZLDQ0,
  vue_notification_wWTm433X42,
  primevue_7rYYRZQLyx,
  storage_5ozezXsAZX,
  i18n_VfGcjrvSkj,
  nats_Jo7eXz1ICQ
]